import React, { useState } from "react"
import tw, { css } from "twin.macro"
import Portal from "../../atoms/portal"
import PhotoGallery from "./photo-gallery"
import CloseButton from "../../atoms/close-button"
import useBodySrollLock from "../../../utils/use-body-scroll-lock"

const PhotoGalleryOverlay = ({ items, onClose }) => {
  const [target, setTarget] = useState()
  useBodySrollLock(target)
  return (
    <Portal>
      <div
        tw="fixed inset-0 w-full h-full flex items-center"
        css={css`
          z-index: 150;
        `}
      >
        <div
          tw="absolute inset-0"
          css={css`
            background-color: rgba(0, 0, 0, 0.97);
          `}
        ></div>
        <div
          ref={setTarget}
          tw="absolute inset-0 overflow-y-auto flex flex-col items-center"
        >
          <PhotoGallery items={items} skipScrollLockClear={true} />
        </div>
        <CloseButton
          onClick={onClose}
          css={[
            tw`absolute top-0 right-0 xl:(right-20) xxl:right-40`,
            css`
              z-index: 9999;
            `,
          ]}
        />
      </div>
    </Portal>
  )
}

export default PhotoGalleryOverlay
